import { useEffect, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

// Components
import Product from '../Product';
import LoadingProducts from '../LoadingProducts';
import AddById from '../AddById';
import CountDown from '../CountDown';

//Styles
import styles from './index.module.sass';

// Queries
import getProductos from '../Queries/getProductos';

export default function ProductsGrid({
  catSelected,
  webservice,
  orderDetail,
  screenSize,
  getCookie,
  history,
  addedArray,
  setAddedArray,
  setOrderData,
  setSessionMessage,
  showAddById,
  setShowAddById,
  device,
  awaitForPath,
  setCatselected,
  menuCategories,
  setAwaitForPath,
}) {
  // For count down
  const target_date = new Date('February 26, 2025 23:59:59').getTime();
  const initial_date = new Date('February 25, 2025 01:00:00').getTime();
  const today = new Date().getTime();
  const [showCount, setShowCount] = useState(target_date > today && today > initial_date);

  const { cat, subcat } = useParams();
  const [productList, setProductlist] = useState({});
  const [categoryName, setCategoryName] = useState('');
  const [loading, setLoading] = useState(false);
  const [noProducts, setNoProducts] = useState(false);

  const { t } = useTranslation('products');

  const getPath = useCallback(async () => {
    setAwaitForPath(true);
    let tmpCat = '';
    let tmpSubCat = '';

    if (menuCategories.length > 0) {
      if (!cat) {
        setCatselected(menuCategories[0]?.subcateg[0]?.numero);
        setAwaitForPath(false);
        return;
      }
      tmpCat = cat.replace(/-/g, ' ');
      if (subcat) tmpSubCat = subcat.replace(/-/g, ' ');
      for (let i = 0; i < menuCategories.length; i++) {
        const { subcateg = [], descri = '', descEN = '' } = menuCategories[i] || {};

        if (
          descri.toLowerCase() === tmpCat.toLowerCase() ||
          descEN.toLowerCase() === tmpCat.toLowerCase()
        ) {
          if (!subcat) setCatselected(menuCategories[i]?.subcateg[0].numero);
          else {
            for (let h = 0; h < subcateg.length; h++) {
              const { descri = '', numero = '', descriEN = '' } = subcateg[h] || {};
              if (
                descri.toLowerCase() === tmpSubCat.toLowerCase() ||
                descriEN.toLowerCase() === tmpSubCat.toLowerCase()
              ) {
                setCatselected(numero);
              }
            }
          }
        }
      }
    }

    setAwaitForPath(false);
  }, [menuCategories, cat, subcat, setCatselected, setAwaitForPath]);

  const getProducts = useCallback(async () => {
    if (!catSelected) return;
    setLoading(true);
    setProductlist([]);
    setCategoryName('');
    const response = await getProductos({
      jsonBody: {
        accion: 'desplegar',
        usuarioOK: getCookie('usuarioOk'),
        folioPedido: getCookie('folioPedido'),
        almacen: getCookie('warehouse'),
        categoria: catSelected,
        idioma: window?.localStorage?.getItem('i18nextLng')?.includes('es') ? 0 : 1,
      },
    });

    const {
      tipoMensaje = 'error',
      categoriaDescri = '',
      productos = [],
      mensaje = '',
    } = response?.getProductosResult || {};

    setSessionMessage(mensaje);

    if (tipoMensaje === 'error') {
      setNoProducts(true);
      setLoading(false);
      return;
    }

    let productsObject = {};
    for (let i = 0; i < productos.length; i++) {
      const { clavePrimaria = '', clave = '' } = productos[i] || {};
      const primaryKey = clavePrimaria !== '' ? clavePrimaria : clave;

      if (productsObject[primaryKey] && productsObject[primaryKey].length > 0)
        productsObject[primaryKey].push(productos[i]);
      else {
        productsObject[primaryKey] = [];
        productsObject[primaryKey].push(productos[i]);
      }
    }

    setNoProducts(false);
    setProductlist(productsObject);
    setCategoryName(categoriaDescri);
    setLoading(false);
  }, [getCookie, catSelected, setSessionMessage]);

  useEffect(() => {
    getProducts();
  }, [getProducts, t]);

  useEffect(() => {
    getPath();
  }, [getPath]);

  return (
    <>
      <div className={`${styles.container} ${styles[screenSize]}`}>
        {showCount && (
          <div className={styles.countDownContainer}>
            {
              <CountDown
                target_date={target_date}
                showCount={showCount}
                setShowCount={setShowCount}
                screenSize={screenSize}
              />
            }
          </div>
        )}
        <div className={`${styles.addById} ${screenSize !== 'desktop' && styles[showAddById]}`}>
          {screenSize !== 'desktop' && (
            <div className={styles.closeAddById}>
              <i
                className={`material-icons-outlined ${styles.closeIcon}`}
                onClick={() => setShowAddById(false)}>
                close
              </i>
            </div>
          )}
          <AddById
            screenSize={screenSize}
            webservice={webservice}
            getCookie={getCookie}
            addedArray={addedArray}
            setAddedArray={setAddedArray}
            setOrderData={setOrderData}
            setSessionMessage={setSessionMessage}
          />
        </div>
        {((loading || awaitForPath) && <LoadingProducts screenSize={screenSize} />) || (
          <>
            <div className={`${styles.gridHeader} ${showCount ? styles.withCountDown : null}`}>
              <div className={styles.gridTitle}>{t('gridTitle')}</div>
              <div className={styles.categoryName}>{categoryName}</div>
            </div>

            <div className={styles.productGrid}>
              {noProducts && <div className={styles.noProducts}>{t('noProducts')}</div>}
              {Object.keys(productList).map((val, key) => {
                return (
                  <Product
                    key={key}
                    product={productList[val] || []}
                    orderDetail={orderDetail}
                    catSelected={catSelected}
                    screenSize={screenSize}
                    webservice={webservice}
                    getCookie={getCookie}
                    addedArray={addedArray}
                    setAddedArray={setAddedArray}
                    setOrderData={setOrderData}
                    setSessionMessage={setSessionMessage}
                    device={device}
                    history={history}
                  />
                );
              })}
            </div>
          </>
        )}
      </div>
    </>
  );
}
